import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-soon',
  templateUrl: './page-soon.component.html',
  styleUrls: ['./page-soon.component.css']
})
export class PageSoonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
